import { AclRule } from "vue-acl";

import DashView from "./components/Dash.vue";
import LoginView from "./components/Login.vue";
import NotFoundView from "./components/404.vue";

import DashboardView from "./components/dashboard/Dashboard.vue";

/* ADMINISTRAÇÃO */

/* Contratos Components */
import ContratoIndex from "./components/administracao/contratos/";
import ContratoForm from "./components/administracao/contratos/form";
import ContratoProcedimento from "./components/administracao/contratos/contratoProcedimento";
import ContratoProcedimentoForm from "./components/administracao/contratos/contratoProcedimentoForm";
import ContratoSubgrupo from "./components/administracao/contratos/contratoSubgrupo";
import ContratoSubgrupoForm from "./components/administracao/contratos/contratoSubgrupoForm";

/* Agendas Components */
import AgendaIndex from "./components/administracao/agendas/";
import AgendaProcedimentosIndex from "./components/administracao/agendas/agendasProcedimentos";
import AgendaSubgruposIndex from "./components/administracao/agendas/agendasSubgrupos";
import NovaAgendaProcedimentos from "./components/administracao/agendas/novaAgendaProcedimentos";
import NovaAgendaSubgrupos from "./components/administracao/agendas/novaAgendaSubgrupos";

/* Distribuição Components */
import DistribuicaoIndex from "./components/distribuicoes/index";
import DistribuicaoAtendimentoIndex from "./components/distribuicoes/atendimentos/index";
import DistribuicaoAtendimentoProcedimentosIndex from "./components/distribuicoes/atendimentos/agendasProcedimentos";
import DistribuicaoAtendimentoSubgruposIndex from "./components/distribuicoes/atendimentos/agendasSubgrupos";
import DistribuicaoAtendimentosForm from "./components/distribuicoes/atendimentos/form";

/* Controle Contrato Components */
/* Contratos Components */
import DistribuicaoContratoIndex from "./components/distribuicoes/contratos/";
import DistribuicaoContratoForm from "./components/distribuicoes/contratos/form";
import DistribuicaoContratoProcedimento from "./components/distribuicoes/contratos/contratoProcedimento";
import DistribuicaoContratoProcedimentoForm from "./components/distribuicoes/contratos/contratoProcedimentoForm";
import DistribuicaoContratoSubgrupo from "./components/distribuicoes/contratos/contratoSubgrupo";
import DistribuicaoContratoSubgrupoForm from "./components/distribuicoes/contratos/contratoSubgrupoForm";

/* Parâmetros Components */
import ParametroIndex from "./components/administracao/parametros/";

/* Tela Inicial Components */
import ComunicadoIndex from "./components/administracao/comunicados";
import ComunicadoForm from "./components/administracao/comunicados/form";

/* Relatórios Components */
import SolicitacaoRelatorioIndex from "./components/administracao/relatorios/solicitacoes/";
import EscalaRelatorioIndex from "./components/administracao/relatorios/escalas/";
import OfertaRelatorioIndex from "./components/administracao/relatorios/ofertas/";
import OfertaAnualRelatorioIndex from "./components/administracao/relatorios/ofertas_anual/";
import OfertaSubgrupoAnualRelatorioIndex from "./components/administracao/relatorios/ofertas_subgrupo_anual/";
import UsuarioRelatorioIndex from "./components/administracao/relatorios/usuarios/";
import AgendaPrestadorRelatorioIndex from "./components/administracao/relatorios/agenda_prestador/";
import ConsumoLimitesRelatorioIndex from "./components/administracao/relatorios/consumo_limites/";
import SolicitacaoSinteticoRelatorioIndex from "./components/administracao/relatorios/solicitacoes_sintetico/";

/* ATENDIMENTO */

/* Solicitação Components */
import SolicitacaoIndex from "./components/atendimentos/solicitacao/";
import Resolucao from "./components/atendimentos/solicitacao/resolucao";
import BoletoIndex from "./components/atendimentos/comuns/impressaoBoleto";

import VerificacaoIndex from "./components/atendimentos/verificacao/";

/* Regulação Components */
import RegulacaoIndex from "./components/atendimentos/regulacao/";
import RegulacaoSolicitacao from "./components/atendimentos/regulacao/solicitacao";

/* Atendimento - falta */
import AtendidoFaltaIndex from "./components/atendimentos/faltas/";

/* CADASTRO */

/* Paciente Components */
import PacienteIndex from "./components/cadastros/pacientes/";
import PacienteForm from "./components/cadastros/pacientes/form";
import PacienteHistorico from "./components/cadastros/pacientes/historico";

/* Profissional Components */
import ProfissionalIndex from "./components/cadastros/profissionais/";
import ProfissionalForm from "./components/cadastros/profissionais/form";

/* Unidades Components */
import UnidadeIndex from "./components/cadastros/unidades/";
import UnidadeForm from "./components/cadastros/unidades/form";

/* Procedimentos Components */
import GrupoProcedimentoIndex from "./components/cadastros/procedimentos/grupos";
import GrupoProcedimentoForm from "./components/cadastros/procedimentos/grupos/form";

import SubgrupoProcedimentoIndex from "./components/cadastros/procedimentos/subgrupos";
import SubgrupoProcedimentoForm from "./components/cadastros/procedimentos/subgrupos/form";

import FormaOrganizacaoProcedimentoIndex from "./components/cadastros/procedimentos/formas_organizacao/";
import FormaOrganizacaoProcedimentoForm from "./components/cadastros/procedimentos/formas_organizacao/form";

import ProcedimentoIndex from "./components/cadastros/procedimentos/";
import ProcedimentoForm from "./components/cadastros/procedimentos/form";

/* Usuario Components */
import UsarioIndex from "./components/cadastros/usuarios";
import UsarioForm from "./components/cadastros/usuarios/Form";
import UsarioAlterarSenha from "./components/cadastros/usuarios/alterarSenha";

/* Integração Components */
import PacientesIntegracaoIndex from "./components/integracao/pacientes/";
import PacientesIntegracaoHistorico from "./components/integracao/pacientes/historico";
import PacientesIntegracaoForm from "./components/integracao/pacientes/form";

/* Preparos Components */
import PreparosIndex from "./components/cadastros/preparos/";
import PreparosForm from "./components/cadastros/preparos/form";

/* Rotas */
const routes = [
	{
		path: "/login",
		component: LoginView,
		meta: {
			rule: new AclRule("public").generate()
		}
	},
	{
		path: "/boleto/:solicitacaoId",
		component: BoletoIndex,
		meta: {
			rule: new AclRule("public").generate()
		}
	},
	{
		path: "/",
		component: DashView,
		meta: {
			requiresAuth: true,
			rule: new AclRule('usuario.basico').generate()
		},
		children: [
			{
				path: "dashboard",
				alias: "",
				component: DashboardView,
				name: "CMC1",
				meta: {
					description: "Início",
					rule: new AclRule('usuario.basico').generate()
				}
			},

			/* ADMINISTRAÇAO */

			/* CONTRATOS ROUTES */
			{
				path: "administracao/contratos",
				component: ContratoIndex,
				name: "CMC2",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.read").generate()
				}
			},
			{
				path: "administracao/contratos/novo",
				component: ContratoForm,
				name: "CMC3",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			{
				path: "administracao/contratos/atualizacao/:contrato_id",
				component: ContratoForm,
				name: "CMC4",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			{
				path: "administracao/contratos/procedimentos/:contrato_id",
				component: ContratoProcedimento,
				name: "CMC5",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.read").generate()
				}
			},
			{
				path: "administracao/contratos/procedimentos/novo/:contrato_id",
				component: ContratoProcedimentoForm,
				name: "CMC6",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			{
				path: "administracao/contratos/procedimentos/atualizacao/:contrato_procedimento_id",
				component: ContratoProcedimentoForm,
				name: "CMC7",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			{
				path: "administracao/contratos/subgrupos/:contrato_id",
				component: ContratoSubgrupo,
				name: "CMC8",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.read").generate()
				}
			},
			{
				path: "administracao/contratos/subgrupos/novo/:contrato_id",
				component: ContratoSubgrupoForm,
				name: "CMC9",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			{
				path: "administracao/contratos/subgrupos/atualizacao/:contrato_subgrupo_id",
				component: ContratoSubgrupoForm,
				name: "CMC10",
				meta: {
					description: "Contratos",
					rule: new AclRule("contrato.write").generate()
				}
			},
			/* AGENDAS ROUTES */
			{
				path: "administracao/agendas",
				component: AgendaIndex,
				name: "CMC11",
				meta: {
					description: "Agendas",
					rule: new AclRule("agenda.read").generate()
				}
			},

			{
				path: "administracao/agendas/visualizar-procedimentos/:contratoId",
				component: AgendaProcedimentosIndex,
				name: "CMC12",
				meta: {
					description: "Agendas",
					rule: new AclRule("agenda.read").generate()
				}
			},
			{
				path: "administracao/agendas/visualizar-subgrupos/:contratoId",
				component: AgendaSubgruposIndex,
				name: "CMC13",
				meta: {
					description: "Agendas",
					rule: new AclRule("agenda.read").generate()
				}
			},

			{
				path: "administracao/agendas/novo-procedimento/:contratoId",
				component: NovaAgendaProcedimentos,
				name: "CMC14",
				meta: {
					description: "Agendas",
					rule: new AclRule("agenda.write").generate()
				}
			},

			{
				path: "administracao/agendas/novo-subgrupo/:contratoId",
				component: NovaAgendaSubgrupos,
				name: "CMC15",
				meta: {
					description: "Agendas",
					rule: new AclRule("agenda.write").generate()
				}
			},

			{
				path: "administracao/parametros",
				component: ParametroIndex,
				name: "CMC16",
				meta: {
					description: "Parâmetros Gerais",
					rule: new AclRule("contrato.write").generate()
				}
			},

			{
				path: "administracao/comunicados",
				component: ComunicadoIndex,
				name: "CMC20231",
				meta: {
					description: "Comunicados",
					rule: new AclRule("contrato.write").generate()
				}
			},

			{
				path: "administracao/comunicados/novo",
				component: ComunicadoForm,
				name: "CMC20232",
				meta: {
					description: "Comunicados",
					rule: new AclRule("contrato.write").generate()
				}
			},

			{
				path: "administracao/comunicados/atualizacao/:comunicado_id",
				component: ComunicadoForm,
				name: "CMC20233",
				meta: {
					description: "Comunicados",
					rule: new AclRule("contrato.write").generate()
				}
			},

			/* DISTRIBUIÇÕES ROUTES */
			{
				path: "distribuicao/distribuir",
				component: DistribuicaoIndex,
				name: "CMC17",
				meta: {
					description: "Distribuições",
					rule: new AclRule("distribuicao.read").generate()
				}
			},

			/* DISTRIBUIÇÕES CONTROLE CONTRATOS ROUTES */
			{
				path: "distribuicao/controle-contratos",
				component: DistribuicaoContratoIndex,
				name: "CMC18",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.read").generate()
				}
			},
			{
				path: "distribuicoes/contratos/novo",
				component: DistribuicaoContratoForm,
				name: "CMC19",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/atualizacao/:contrato_id",
				component: DistribuicaoContratoForm,
				name: "CMC20",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/procedimentos/:contrato_id",
				component: DistribuicaoContratoProcedimento,
				name: "CMC21",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/procedimentos/novo/:contrato_id",
				component: DistribuicaoContratoProcedimentoForm,
				name: "CMC22",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/procedimentos/atualizacao/:contrato_procedimento_id",
				component: DistribuicaoContratoProcedimentoForm,
				name: "CMC23",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/subgrupos/:contrato_id",
				component: DistribuicaoContratoSubgrupo,
				name: "CMC24",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").generate()
				}
			},
			{
				path: "distribuicoes/contratos/subgrupos/novo/:contrato_id",
				component: DistribuicaoContratoSubgrupoForm,
				name: "CMC25",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").and('usuario.read').generate()
				}
			},
			{
				path: "distribuicoes/contratos/subgrupos/atualizacao/:contrato_subgrupo_id",
				component: DistribuicaoContratoSubgrupoForm,
				name: "CMC26",
				meta: {
					description: "Controle de Contratos",
					rule: new AclRule("distribuicao.contrato.write").and('usuario.read').generate()
				}
			},

			/* DISTRIBUIÇÕES CONTROLE ATENDIMENTOS ROUTES */
			{
				path: "distribuicao/controle-atendimentos",
				component: DistribuicaoAtendimentoIndex,
				name: "CMC27",
				meta: {
					description: "Controle da Agenda",
					rule: new AclRule("distribuicao.agenda.read").and('usuario.read').generate()
				}
			},

			{
				path: "distribuicao/controle-atendimentos/visualizar-procedimentos/:distribuicaoContratoId",
				component: DistribuicaoAtendimentoProcedimentosIndex,
				name: "CMC28",
				meta: {
					description: "Controle da Agenda",
					rule: new AclRule("distribuicao.agenda.write").and('usuario.read').generate()
				}
			},

			{
				path: "distribuicao/controle-atendimentos/criar-atendimentos/:id",
				component: DistribuicaoAtendimentosForm,
				name: "CMC29",
				meta: {
					description: "Controle da Agenda",
					rule: new AclRule("distribuicao.agenda.write").and('usuario.read').generate(),
					titulo: "Criar",
					acao: "criar"
				}
			},

			{
				path: "distribuicao/controle-atendimentos/visualizar-subgrupos/:distribuicaoContratoId",
				component: DistribuicaoAtendimentoSubgruposIndex,
				name: "CMC30",
				meta: {
					description: "Controle da Agenda",
					rule: new AclRule("distribuicao.agenda.write").and('usuario.read').generate()
				}
			},

			/* RELATORIOS ROUTES */
			{
				path: "administracao/relatorios/solicitacoes",
				component: SolicitacaoRelatorioIndex,
				name: "CMC31",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.solicitacao").generate()
				}
			},
			{
				path: "administracao/relatorios/solicitacoes-sintetico",
				component: SolicitacaoSinteticoRelatorioIndex,
				name: "CMC74",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.solicitacao").generate()
				}
			},
			{
				path: "administracao/relatorios/escalas",
				component: EscalaRelatorioIndex,
				name: "CMC32",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.escalas").generate()
				}
			},
			{
				path: "administracao/relatorios/ofertas",
				component: OfertaRelatorioIndex,
				name: "CMC33",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.ofertas").generate()
				}
			},
			{
				path: "administracao/relatorios/ofertas-anual",
				component: OfertaAnualRelatorioIndex,
				name: "CMC100",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.ofertas").generate()
				}
			},
			{
				path: "administracao/relatorios/ofertas-subgrupos-anual",
				component: OfertaSubgrupoAnualRelatorioIndex,
				name: "CMC101",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.ofertas").generate()
				}
			},
			{
				path: "administracao/relatorios/usuarios",
				component: UsuarioRelatorioIndex,
				name: "CMC34",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.usuarios").generate()
				}
			},
			{
				path: "administracao/relatorios/agenda-prestador",
				component: AgendaPrestadorRelatorioIndex,
				name: "CMC35",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.agenda.prestador").generate()
				}
			},
			{
				path: "administracao/relatorios/consumo-limites",
				component: ConsumoLimitesRelatorioIndex,
				name: "CMC31",
				meta: {
					description: "Relatórios",
					rule: new AclRule("relatorio.solicitacao").generate()
				}
			},

			/* ATENDIMENTOS */

			/* MARCAÇÃO ROUTES */
			{
				path: "atendimentos/solicitacao",
				component: SolicitacaoIndex,
				name: "CMC36",
				meta: {
					description: "Solicitação de Atendimentos",
					rule: new AclRule("solicitacao.create").generate()
				}
			},

			{
				path: "atendimentos/solicitacao/resolucao/:solicitacaoId?",
				component: Resolucao,
				name: "CMC37",
				meta: {
					description: "Solicitação de Atendimentos",
					rule: new AclRule("solicitacao.create").or('solicitacao.regular').generate()
				}
			},

			/* REGULAÇÃO ROUTES */
			{
				path: "atendimentos/regulacao",
				component: RegulacaoIndex,
				name: "CMC38",
				meta: {
					description: "Regulação de Atendimentos",
					rule: new AclRule("solicitacao.regular").generate()
				}
            },
            {
                path: "atendimentos/regulacao/solicitacao/:solicitacaoId",
                component: RegulacaoSolicitacao,
                name: "CMC39",
                meta: {
                    description: "Regulação de Atendimentos",
                    rule: new AclRule("solicitacao.regular").generate()
                }
            },

			/* VERIFICAÇÃO ROUTES */
			{
				path: "atendimentos/verificacao",
				component: VerificacaoIndex,
				name: "CMC40",
				meta: {
					description: "Regulação de Atendimentos",
					rule: new AclRule("solicitacao.read").generate()
				}
			},

			/* ATENDIDO - FALTA ROUTES */
			{
				path: "atendimentos/atendido-falta",
				component: AtendidoFaltaIndex,
				name: "CMC41",
				meta: {
					description: "Regulação de Atendimentos",
					rule: new AclRule("solicitacao.atendidoFalta").generate()
				}
			},

			/* CADASTROS */

			/* PACIENTE ROUTES */
			{
				path: "cadastros/pacientes",
				component: PacienteIndex,
				name: "CMC42",
				meta: {
					description: "Pacientes",
					rule: new AclRule("paciente.read").generate()
				}
			},
			{
				path: "cadastros/pacientes/novo",
				component: PacienteForm,
				name: "CMC43",
				meta: {
					description: "Pacientes",
					rule: new AclRule("paciente.write").generate()
				}
			},
			{
				path: "/cadastros/pacientes/editar/:pacienteId",
				component: PacienteForm,
				name: "CMC44",
				meta: {
					description: "Pacientes",
					rule: new AclRule("paciente.write").generate()
				}
			},
			{
				path: "/cadastros/pacientes/historico/:pacienteId",
				component: PacienteHistorico,
				name: "CMC45",
				meta: {
					description: "Pacientes",
					rule: new AclRule("paciente.read").generate()
				}
			},

			/* PROFISSIONAL ROUTES */
			{
				path: "cadastros/profissionais",
				component: ProfissionalIndex,
				name: "CMC46",
				meta: {
					description: "Profissionais",
					rule: new AclRule("profissional.read").generate()
				}
			},
			{
				path: "cadastros/profissionais/novo",
				component: ProfissionalForm,
				name: "CMC47",
				meta: {
					description: "Profissionais",
					rule: new AclRule("profissional.write").generate()
				}
			},
			{
				path: "cadastros/profissionais/editar/:profissionalId",
				component: ProfissionalForm,
				name: "CMC48",
				meta: {
					description: "Profissionais",
					rule: new AclRule("profissional.write").generate()
				}
			},

			/* UNIDADES ROUTES */
			{
				path: "cadastros/unidades",
				component: UnidadeIndex,
				name: "CMC49",
				meta: {
					description: "Unidades",
					rule: new AclRule("unidade.read").generate()
				}
            },
            {
                path: "cadastros/unidades/novo",
                component: UnidadeForm,
                name: "CMC50",
                meta: {
                    description: "Unidades",
                    rule: new AclRule("unidade.write").generate()
                }
            },
            {
                path: "cadastros/unidades/editar/:unidade_id",
                component: UnidadeForm,
                name: "CMC51",
                meta: {
                    description: "Unidades",
                    rule: new AclRule("unidade.write").generate()
                }
            },

			/* GRUPO PROCEDIMENTOS ROUTES */
			{
				path: "cadastros/grupos-procedimento",
				component: GrupoProcedimentoIndex,
				name: "CMC52",
				meta: {
					description: "Grupos de Procedimento",
					rule: new AclRule("grupo.read").generate()
				}
			},
			{
				path: "cadastros/grupos-procedimento/novo",
				component: GrupoProcedimentoForm,
				name: "CMC53",
				meta: {
					description: "Grupos de Procedimento",
					rule: new AclRule("grupo.write").generate()
				}
			},
			{
				path: "cadastros/grupos-procedimento/editar/:grupoId",
				component: GrupoProcedimentoForm,
				name: "CMC54",
				meta: {
					description: "Grupos de Procedimento",
					rule: new AclRule("grupo.write").generate()
				}
			},

			/* SUBGRUPO PROCEDIMENTOS ROUTES */
			{
				path: "cadastros/subgrupos-procedimento",
				component: SubgrupoProcedimentoIndex,
				name: "CMC55",
				meta: {
					description: "Subgrupos de Procedimentos",
					rule: new AclRule("subgrupo.read").generate()
				}
			},
			{
				path: "cadastros/subgrupos-procedimento/novo",
				component: SubgrupoProcedimentoForm,
				name: "CMC56",
				meta: {
					description: "Subgrupos de Procedimentos",
					rule: new AclRule("subgrupo.write").generate()
				}
			},
			{
				path: "cadastros/subgrupos-procedimento/editar/:subgrupoId",
				component: SubgrupoProcedimentoForm,
				name: "CMC57",
				meta: {
					description: "Subgrupos de Procedimentos",
					rule: new AclRule("subgrupo.write").generate()
				}
			},

			/* FORMAS DE ORGANIZAÇÃO PROCEDIMENTOS ROUTES */
			{
				path: "cadastros/formas-organizacao-procedimento",
				component: FormaOrganizacaoProcedimentoIndex,
				name: "CMC58",
				meta: {
					description: "Formas de Organização dos Procedimentos",
					rule: new AclRule("forma.organizacao.read").generate()
				}
			},
			{
				path: "cadastros/formas-organizacao-procedimento/novo",
				component: FormaOrganizacaoProcedimentoForm,
				name: "CMC59",
				meta: {
					description: "Formas de Organização dos Procedimentos",
					rule: new AclRule("forma.organizacao.write").generate()
				}
			},
			{
				path: "cadastros/formas-organizacao-procedimento/editar/:formaOrganizacaoId",
				component: FormaOrganizacaoProcedimentoForm,
				name: "CMC60",
				meta: {
					description: "Formas de Organização dos Procedimentos",
					rule: new AclRule("forma.organizacao.write").generate()
				}
			},

			/* PROCEDIMENTOS ROUTES */
			{
				path: "cadastros/procedimentos",
				component: ProcedimentoIndex,
				name: "CMC61",
				meta: {
					description: "Procedimentos",
					rule: new AclRule("procedimento.read").generate()
				}
			},
			{
				path: "cadastros/procedimentos/novo",
				component: ProcedimentoForm,
				name: "CMC62",
				meta: {
					description: "Procedimentos",
					rule: new AclRule("procedimento.write").generate()
				}
			},
			{
				path: "cadastros/procedimentos/editar/:procedimentoId",
				component: ProcedimentoForm,
				name: "CMC63",
				meta: {
					description: "Procedimentos",
					rule: new AclRule("procedimento.write").generate()
				}
			},

			/* USUARIOS ROUTES */
			{
				path: "cadastros/usuarios",
				component: UsarioIndex,
				name: "CMC64",
				meta: {
					description: "Usuários do Sistema",
					rule: new AclRule("usuario.getAll").generate()
				}
			},
			{
				path: "cadastros/usuarios/novo",
				component: UsarioForm,
				name: "CMC65",
				meta: {
					description: "Usuários do Sistema",
					rule: new AclRule("usuario.write").generate()
				}
			},
			{
				path: "cadastros/usuarios/atualizacao/:idUsuario",
				component: UsarioForm,
				name: "CMC66",
				meta: {
					description: "Usuários do Sistema",
					rule: new AclRule("usuario.write").generate()
				}
			},
			{
				path: "cadastros/usuarios/alterar-senha",
				component: UsarioAlterarSenha,
				name: "CMC67",
				meta: {
					description: "Alterar senha",
					rule: new AclRule("usuario.updatePassword").generate()
				}
			},

			/* INTEGRAÇÃO ROUTES */
			{
				path: "integracao/pacientes",
				component: PacientesIntegracaoIndex,
				name: "CMC68",
				meta: {
					description: "Integração",
					rule: new AclRule("paciente-integracao.read").generate()
				}
			},
			{
				path: "integracao/pacientes/historico/:cdPessoa",
				component: PacientesIntegracaoHistorico,
				name: "CMC69",
				meta: {
					description: "Integração",
					rule: new AclRule("usuario.getAll").generate()
				}
			},
			{
				path: "integracao/pacientes/visualizar/:cdPessoa",
				component: PacientesIntegracaoForm,
				name: "CMC70",
				meta: {
					description: "Integração",
					rule: new AclRule("usuario.getAll").generate()
				}
			},

			/* PREPAROS ROUTES */

			{
				path: "cadastros/preparos",
				component: PreparosIndex,
				name: "CMC71",
				meta: {
					description: "Preparos",
					rule: new AclRule("usuario.getAll").generate()
				}
			},
			{
				path: "cadastros/preparos/novo",
				component: PreparosForm,
				name: "CMC72",
				meta: {
					description: "Preparos",
					rule: new AclRule("usuario.getAll").generate()
				}
			},
			{
				path: "cadastros/preparos/editar/:preparoId",
				component: PreparosForm,
				name: "CMC73",
				meta: {
					description: "Preparos",
					rule: new AclRule("usuario.getAll").generate()
				}
			},

		]
	},
	{
		// not found handler
		path: "*",
		component: NotFoundView,
		meta: {
			description: "Error",
			rule: new AclRule("public").generate()
		}
	}
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js